const en = {
  hi: "Hi",
  login: "Login",
  myOrders: "My Orders",
  logout: "Logout",
  viewFullMenu: "View Full Menu",
  featuredItems: "Featured Items",
  featuredItemsDesc:
    "Handpicked favorites crafted with love and fresh ingredients",
  ourMenu: "Our Menu",
  exploreOurMenu: "Explore Our Menu",
  exploreOurMenuDesc:
    "Discover delicious dishes across all your favorite categories",
  home: "Home",
  call: "Call",
  aboutUs: "About Us",
  contactUs: "Contact Us",
  quickLinks: "Quick Links",
  viewCart: "View Cart",
  ourSpecialties: "Our Specialties",
  location: "Location",
  phone: "Phone",
  hours: "Hours",
  yourcart: "My Cart",
  cartisempty: "Your cart is empty now. Add items to place an order.",
  yourCartIsEmpty: "Your cart is empty",
  addItemsToGetStarted: "Add some delicious items to get started!",

  itemTotal: "Item Total",
  gst: "GST",
  vat: "VAT",
  gstRate: 0.05,
  toPay: "TO PAY",

  message: "Terms and Conditions Apply",
  term1: "Dish photos may differ from actual presentation.",
  term2: "Items are subject to availability.",
  term3: "Please contact us for order confirmation.",
  term4: "Delivery time for every order is 30–45 minutes. Please cooperate.",

  customerDetails: "Customer Details",

  filteredItems: "Sorry, the item was not found",
  filteredItemDesc:
    "Sorry, we couldn't find anything. Please search from all categories",
  allRightsReserved: "All rights reserved.",
  welcomeMessage:
    "Welcome to {{name}}! We serve delicious, authentic cuisine prepared with fresh ingredients and traditional recipes. Visit us for an unforgettable dining experience.",
  searchPlaceholder: "Search for dishes...",
  searchAllCategories: "Search in all categories",
  vegOnly: "VEG",
  categories: "Categories",
  add: "Add",
  restaurantOffline:
    "The restaurant is currently offline. You can browse items but cannot place orders.",
  backToHome: "Back to Home",
  welcomeBack: "Welcome Back",
  createAccount: "Create Account",
  loginToContinue: "Login to continue",
  signupToGetStarted: "Sign up to get started",

  fullName: "Full Name",
  enterFullName: "Enter your full name",

  mobileNumber: "Mobile Number",
  enterMobileNumber: "Enter 10-digit mobile number",

  emailOptional: "Email (Optional)",
  enterEmail: "your.email@example.com",

  sendOtp: "Send OTP",
  sendingOtp: "Sending OTP...",

  verifyOtp: "Verify OTP",
  otpInstruction: "Enter the 6-digit code sent to your phone",

  changeNumber: "Change number",
  resendOtp: "Resend OTP",
  resendOtpIn: "Resend OTP in <strong>{{seconds}}s</strong>",

  dontHaveAccount: "Don't have an account?",
  alreadyHaveAccount: "Already have an account?",
  signup: "Create account",

  otpSentTo: "OTP sent to {{phone}}",

  creatingAccount: "Creating Account...",

  invalidMobile: "Enter a valid 10-digit mobile number",
  invalidEmail: "Enter a valid email address",
  otpRequired: "Enter complete 6-digit OTP",

  otpSent: "OTP sent successfully.",
  otpResent: "OTP resent successfully.",
  loginFailed: "Login failed",
  signupFailed: "Signup failed",
  resendFailed: "Resend failed",

  loginSuccess: "Login successful. Redirecting...",
  signupSuccess: "Signup successful. Redirecting...",

  somethingWentWrong: "Something went wrong. Please try again.",
  otpVerificationFailed: "OTP verification failed",

  orders: "My Orders",
  completed: "Completed",
  onProcess: "On Process",
  cancelled: "Cancelled",
  noOrdersFound: "No orders found.",
  totalPayment: "Total Payment",
  loadingOrders: "Loading orders...",
  orderCancelledOrRemoved:
    "This order was cancelled or items were removed by admin.",
  showMoreItems: "Show more items",
  showFewerItems: "Show fewer items",

  address: "Address",
  recentAddresses: "Recent Addresses",
  noRecentAddresses: "No recent addresses found.",
  select: "Select",

  houseFlat: "House / Flat No.",
  area: "Area",
  landmarkOptional: "Landmark (Optional)",
  pincode: "Pincode",

  orderingUnavailable: "Sorry, ordering is currently unavailable",
  placeOrderWhatsapp: "Place Order on WhatsApp",
  submit:"Submit",

  yourOrder: "Your Order",
  currentOrder: "Current Order",
  previousOrders: "Previous Orders",
  newOrder: "New Order",
  item: "Item",
  qty: "Qty",
  note: "Note",
  addNote: "Add Note",
  ordered: "Ordered",
  queued: "Queued",
  preparing: "Preparing",
  delivered: "Delivered",
  pending: "Pending",
  orderedItems: "Ordered Items",
  totalAmount: "Total Amount",
  placeOrder: "Place Order",
  placingOrder: "Placing...",
  noNewItems: "No new items to place",
  waitingForApproval: "Waiting for Approval",
  tableRequestPending: "Your table access request is pending. You can place orders once the restaurant accepts your request.",
  browseMenu: "Browse Menu",
  itemsInCart: "Items in Cart",
  orderSummary: "Order Summary",
  shareOrder: "Share Order",
  tableCode: "Table Code",
  shareCode: "Share this code with others at your table",
  processing: "Processing...",
  orderPlacedSuccessfully: "Order Placed Successfully!",
  redirectingToHome: "Redirecting to home page...",
  total: "Total",
  items: "Items",
  removeItem: "Remove item",
  packageCharge: "Packaging Charges",
  callWaiter: "Call a Waiter",
  WhatsappMessageHeader: "Hello. Please find the below order.",
};

export default en;
